import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMobileMenu } from 'core/redux/menu/actions';
import { isMobileMenuOpen } from 'core/redux/menu/selectors';
import Hamburger from 'assets/hamburger.inline.svg';
import * as styles from './OpenMenuButton.module.scss';
import useLgBreakpoint from '../../hooks/useLgBreakpoint';

export type OpenMenuButtonProps = Omit<
    React.HTMLAttributes<HTMLButtonElement>,
    'onClick' | 'type' | 'aria-haspopup' | 'aria-expanded'
>;

// menu shows up on screens smaller than 1244px as the full nav is very wide
export default function OpenMenuButton({
    className,
    ...props
}: OpenMenuButtonProps) {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const isOpen = useSelector(isMobileMenuOpen);
    const isSmallScreen = useLgBreakpoint();
    const handleClick = () => {
        dispatch(toggleMobileMenu());
    };

    return (
        <button
            {...props}
            className={classnames(className, styles.root)}
            onClick={handleClick}
            type="button"
            aria-haspopup
            aria-hidden={!isSmallScreen}
            aria-expanded={isOpen && isSmallScreen}
            tabIndex={isSmallScreen ? 0 : -1}
        >
            <span className="sr-only">
                {formatMessage({ id: `nav.${isOpen ? 'close' : 'open'}` })}
            </span>
            <Hamburger />
        </button>
    );
}
